import React from 'react';
import { Button, IconButton, TextField, Card, CardHeader, CardContent, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Tooltip, Menu, MenuItem, InputLabel, DialogTitle, Dialog } from '@material-ui/core';
import styles from '../activities/activities_new/newactivity.module.css';
import status from '../activities/activities_new/status.module.css';
import i18n from '../../i18n/i18n';
import { wentRight, wentWrong } from '../../utils/ToastConfig';
import axios from '../../utils/AxiosWrapper';
import DateAndTime from '../activities/date_and_time/DateAndTime';
import _ from 'lodash';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import ReactSelect from '../../utils/ReactSelect';
import { MoonLoader } from 'react-spinners';

export default class ReportByCropForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activityObj: {},
            allCrops: [],
            selectedCrop: null,
            loading: false,
        };
    };

    componentDidMount = () => {
        axios.get('api/report/crops')
            .then(res => {
                console.log("CROPS IGOR ", res); this.setState({
                    allCrops: res.data.data.map(crop => ({
                        value: crop.id, label: crop.naziv
                    }))
                })
            })
            .catch(err => { console.log(err) })

        // axios.get('api/crop/crops_by_client').then(res => {
        //     console.log("CROPS BY CLIENT ", res);
        //     this.setState({
        //         allCrops: res.data.data.map(crop => ({
        //             value: crop.id_kultura, label: crop.kultura_naziv
        //         }))
        //     })

        // }).catch(err => {
        //     console.log(err)
        // })
    };

    goTo = (path) => {
        if (this.props.onClose && path === '/') {
            this.props.onClose();
            return;
        }
        if (this.props.history) {
            this.props.history.push(path);
        }
    };

    handleDateAndTime = () => this.setState({ dateAndTimeOpen: !this.state.dateAndTimeOpen });

    handleDateAndTimeObj = (startDate, endDate, startTime, endTime) => {
        let obj = this.state.activityObj;
        obj.datum_pocetka = startDate;
        obj.datum_zavrsetka = endDate;
        obj.vreme_pocetka = startTime;
        obj.vreme_zavrsetka = endTime;
        this.setState({ activityObj: obj }, () => this.handleDateAndTime());
    };



    deleteDateAndTime = () => {
        let obj = this.state.activityObj;
        delete obj.datum_pocetka;
        delete obj.datum_zavrsetka;
        delete obj.vreme_pocetka;
        delete obj.vreme_zavrsetka;
        this.setState({ activityObj: obj });
    };


    generateReport = () => {
        this.setState({ loading: true });
        axios.post('api/report/agroimpexReport', {
            startDate: this.state.activityObj.datum_pocetka,
            endDate: this.state.activityObj.datum_zavrsetka,
            id_kultura: this.state.selectedCrop.value
        })
            .then(res => {
                console.log("CROPS report ", res)

                const rows = res && res.data && res.data.data && Array.isArray(res.data.data.rows) ? res.data.data.rows :
                    (res && res.data && Array.isArray(res.data.rows) ? res.data.rows : []);

                if (rows.length > 0) {
                    const excelData = rows.map(item => ({
                        'Naziv table': item.naziv_tabla,
                        'Naziv sorte': item.naziv_sorte,
                        'Troškovi materijala po sortama': parseFloat(item.trosak_materijala) || 0,
                        'Troškovi radnika po sortama': parseFloat(item.trosak_rada) || 0,
                        'Ostali troškovi po sortama': parseFloat(item.trosak_ostalih) || 0,
                        'Zbirni troškovi po sortama po tabli': parseFloat(item.ukupan_trosak) || 0,
                    }));

                    try {
                        console.log('ReportByCropForm export: rows in Excel:', rows.length, rows[0]);

                        const ws = XLSX.utils.json_to_sheet(excelData);
                        ws['!cols'] = [
                            { wpx: 220 },
                            { wpx: 220 },
                            { wpx: 220 },
                            { wpx: 220 },
                            { wpx: 220 },
                            { wpx: 240 },
                        ];
                        ws['!rows'] = [{ hpx: 30 }];

                        // Optional green header background if supported
                        if (ws['!ref']) {
                            const headerRange = XLSX.utils.decode_range(ws['!ref']);
                            for (let c = headerRange.s.c; c <= headerRange.e.c; c++) {
                                const cellAddress = XLSX.utils.encode_cell({ r: 0, c });
                                if (!ws[cellAddress]) continue;
                                ws[cellAddress].s = {
                                    fill: {
                                        patternType: 'solid',
                                        fgColor: { rgb: 'FFB6D7A8' },
                                    },
                                    font: { bold: true }
                                };
                            }
                        }

                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, `Izveštaj po kulturi ${this.state.selectedCrop.label}`);

                        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                        const blob = new Blob([wbout], { type: 'application/octet-stream' });
                        FileSaver.saveAs(blob, `Izveštaj po kulturi ${this.state.selectedCrop.label} od ${this.state.activityObj.datum_pocetka} do ${this.state.activityObj.datum_zavrsetka}.xlsx`);

                        console.log('ReportByCropForm export done');
                    } catch (err) {
                        wentWrong(i18n.t('Something went wrong with the report export'));
                        console.error('1000 export error', err);
                    }
                }
            })
            .catch(err => { console.log(err) })
            .finally(() => {
                this.setState({ loading: false });
                this.props.onClose();
            });
    }


    render() {
        let saveDisabled = true;
        if (this.state.activityObj.datum_pocetka &&
            this.state.selectedCrop) {
            saveDisabled = false;
        };

        return (
            <Dialog open={this.props.open}
                onClose={this.props.onClose}
                fullWidth={false}
                disableBackdropClick
                maxWidth="sm"
                aria-labelledby="responsive-dialog-title">
                <DialogTitle disableTypography={true} style={{ background: '#04764e' }} className="responsive-dialog-title">
                    {i18n.t('Report')}
                    <IconButton onClick={this.props.onClose}>
                        <span className="icon-cancel-circle closeIcon" />
                    </IconButton>
                </DialogTitle>
                <div className={styles.page} style={{ width: '500px', padding: '50px' }}>
                    <div className={styles.section}>
                        <div className={styles.title_container}>
                            <div className={styles.title_left}>
                                <img src="./date.svg" height='26px' className={styles.title_icon} />
                                <div className={styles.section_title}>{i18n.t('Date')}*</div>

                                {this.state.activityObj.vreme_pocetka === undefined &&
                                    this.state.activityObj.vreme_zavrsetka === undefined &&
                                    this.state.activityObj.datum_pocetka === undefined &&
                                    this.state.activityObj.datum_zavrsetka === undefined &&
                                    <div className={styles.add_button} onClick={() => this.handleDateAndTime()}>
                                        <img src="./add.svg" className={styles.add_icon} height='18px' onClick={() => this.handleDateAndTime()} />
                                    </div>
                                }
                            </div>
                        </div>
                        {this.state.activityObj.vreme_pocetka === undefined &&
                            this.state.activityObj.vreme_zavrsetka === undefined &&
                            this.state.activityObj.datum_pocetka === undefined &&
                            this.state.activityObj.datum_zavrsetka === undefined &&
                            <div className={styles.content_container}>
                                <div className={styles.content_empty}>{i18n.t('You have no selected date')}</div>
                            </div>
                        }
                        {this.state.activityObj.vreme_pocetka !== undefined &&
                            this.state.activityObj.vreme_zavrsetka !== undefined &&
                            this.state.activityObj.datum_pocetka !== undefined &&
                            this.state.activityObj.datum_zavrsetka !== undefined &&
                            <div className={styles.content_container}>
                                <div className={styles.content_border} />
                                <div className={styles.content_between}>
                                    <div className={styles.content_flex}>
                                        {this.state.activityObj.datum_pocetka &&
                                            <div>
                                                <div className={styles.working_operation_color}>
                                                    {i18n.t('Start date')}:
                                                </div>
                                                <div className={styles.working_operation}>
                                                    {this.state.activityObj.datum_pocetka}
                                                </div>
                                            </div>
                                        }
                                        {this.state.activityObj.datum_zavrsetka &&
                                            <div>
                                                <div className={styles.working_operation_color}>
                                                    {i18n.t('End date')}:
                                                </div>
                                                <div className={styles.working_operation}>
                                                    {this.state.activityObj.datum_zavrsetka}
                                                </div>
                                            </div>
                                        }

                                    </div>
                                    {this.state.loading ? null : <img src="./delete.svg" height="32px" className={styles.delete_button} onClick={() => this.deleteDateAndTime()} />}
                                </div>
                            </div>
                        }
                    </div>


                    <div style={{ marginBottom: '150px' }}>
                        <ReactSelect
                            isDisabled={this.state.loading}
                            closeMenuOnSelect={true}
                            isClearable={true}
                            value={this.state.selectedCrop}
                            maxMenuHeight={150}
                            menuPlacement="auto"
                            onChange={(e) => { this.setState({ selectedCrop: e }) }}
                            options={this.state.allCrops}
                            label={i18n.t('Crop')}
                            className="react-select-dropdown"
                            classNamePrefix="select"
                            styles={{ indicatorSeparator: () => { }, dropdownIndicator: defaultStyles => ({ ...defaultStyles, color: 'white' }), clearIndicator: defaultStyles => ({ ...defaultStyles, color: 'white' }) }}
                            placeholder={i18n.t('Select')}
                        />
                    </div>
                    <div style={{ marginBottom: '80px', display: 'flex', justifyContent: 'center' }}>
                        {this.state.loading ? (
                            <MoonLoader loading={this.state.loading} size={50} />
                        ) :
                            <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                                <div className={styles.save_button} onClick={() => this.goTo('/')}>
                                    {i18n.t('Cancel')}
                                </div>
                                <div className={saveDisabled ? styles.save_button_disabled2 : styles.save_button2} onClick={() => {
                                    this.generateReport();
                                }}>

                                    {(i18n.t('Generate report'))}
                                </div>
                            </div>
                        }
                    </div>


                    {this.state.dateAndTimeOpen && <DateAndTime open={this.state.dateAndTimeOpen} handleClose={this.handleDateAndTime} handleDateAndTimeObj={this.handleDateAndTimeObj} activityObj={this.state.activityObj} noTime={true} />}

                </div>
            </Dialog>
        );
    }
}